import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

    /**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
    const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: login.url(options),
        method: 'get',
    })

            /**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
        loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: login.url(options),
            method: 'get',
        })
            /**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
 * @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
 * @route '/login'
 */
        loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: login.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    login.form = loginForm
/**
 * @see routes/web.php:59
 * @route '/logout'
 */
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
 * @see routes/web.php:59
 * @route '/logout'
 */
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
 * @see routes/web.php:59
 * @route '/logout'
 */
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

    /**
 * @see routes/web.php:59
 * @route '/logout'
 */
    const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: logout.url(options),
        method: 'post',
    })

            /**
 * @see routes/web.php:59
 * @route '/logout'
 */
        logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: logout.url(options),
            method: 'post',
        })
    
    logout.form = logoutForm
/**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
    const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: home.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
        homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: home.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\HomeController::__invoke
 * @see app/Http/Controllers/HomeController.php:16
 * @route '/'
 */
        homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: home.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    home.form = homeForm
/**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: '/about',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
    const aboutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: about.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
        aboutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: about.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::about
 * @see app/Http/Controllers/PublicController.php:31
 * @route '/about'
 */
        aboutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: about.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    about.form = aboutForm
/**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
export const projects = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: projects.url(options),
    method: 'get',
})

projects.definition = {
    methods: ["get","head"],
    url: '/projects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
projects.url = (options?: RouteQueryOptions) => {
    return projects.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
projects.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: projects.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
projects.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: projects.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
    const projectsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: projects.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
        projectsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: projects.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::projects
 * @see app/Http/Controllers/PublicController.php:44
 * @route '/projects'
 */
        projectsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: projects.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    projects.form = projectsForm
/**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
export const blog = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blog.url(options),
    method: 'get',
})

blog.definition = {
    methods: ["get","head"],
    url: '/blog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
blog.url = (options?: RouteQueryOptions) => {
    return blog.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
blog.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: blog.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
blog.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: blog.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
    const blogForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: blog.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
        blogForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: blog.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::blog
 * @see app/Http/Controllers/PublicController.php:70
 * @route '/blog'
 */
        blogForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: blog.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    blog.form = blogForm
/**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
export const certificates = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: certificates.url(options),
    method: 'get',
})

certificates.definition = {
    methods: ["get","head"],
    url: '/certificates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
certificates.url = (options?: RouteQueryOptions) => {
    return certificates.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
certificates.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: certificates.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
certificates.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: certificates.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
    const certificatesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: certificates.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
        certificatesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: certificates.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::certificates
 * @see app/Http/Controllers/PublicController.php:122
 * @route '/certificates'
 */
        certificatesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: certificates.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    certificates.form = certificatesForm
/**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
export const testimonials = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: testimonials.url(options),
    method: 'get',
})

testimonials.definition = {
    methods: ["get","head"],
    url: '/testimonials',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
testimonials.url = (options?: RouteQueryOptions) => {
    return testimonials.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
testimonials.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: testimonials.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
testimonials.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: testimonials.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
    const testimonialsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: testimonials.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
        testimonialsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: testimonials.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::testimonials
 * @see app/Http/Controllers/PublicController.php:131
 * @route '/testimonials'
 */
        testimonialsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: testimonials.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    testimonials.form = testimonialsForm
/**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
    const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: contact.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
        contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: contact.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::contact
 * @see app/Http/Controllers/PublicController.php:138
 * @route '/contact'
 */
        contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: contact.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    contact.form = contactForm
/**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
export const badges = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: badges.url(options),
    method: 'get',
})

badges.definition = {
    methods: ["get","head"],
    url: '/badges',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
badges.url = (options?: RouteQueryOptions) => {
    return badges.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
badges.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: badges.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
badges.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: badges.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
    const badgesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: badges.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
        badgesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: badges.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PublicController::badges
 * @see app/Http/Controllers/PublicController.php:145
 * @route '/badges'
 */
        badgesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: badges.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    badges.form = badgesForm
/**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
export const chat = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chat.url(options),
    method: 'get',
})

chat.definition = {
    methods: ["get","head"],
    url: '/chat',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
chat.url = (options?: RouteQueryOptions) => {
    return chat.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
chat.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: chat.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
chat.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: chat.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
    const chatForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: chat.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
        chatForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: chat.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\ChatController::chat
 * @see app/Http/Controllers/ChatController.php:18
 * @route '/chat'
 */
        chatForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: chat.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    chat.form = chatForm
/**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
export const linkedin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: linkedin.url(options),
    method: 'get',
})

linkedin.definition = {
    methods: ["get","head"],
    url: '/linkedin',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
linkedin.url = (options?: RouteQueryOptions) => {
    return linkedin.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
linkedin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: linkedin.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
linkedin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: linkedin.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
    const linkedinForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: linkedin.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
        linkedinForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: linkedin.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\LinkedinController::linkedin
 * @see app/Http/Controllers/LinkedinController.php:11
 * @route '/linkedin'
 */
        linkedinForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: linkedin.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    linkedin.form = linkedinForm
/**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
export const instagram = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: instagram.url(options),
    method: 'get',
})

instagram.definition = {
    methods: ["get","head"],
    url: '/instagram',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
instagram.url = (options?: RouteQueryOptions) => {
    return instagram.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
instagram.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: instagram.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
instagram.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: instagram.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
    const instagramForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: instagram.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
        instagramForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: instagram.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\InstagramController::instagram
 * @see app/Http/Controllers/InstagramController.php:11
 * @route '/instagram'
 */
        instagramForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: instagram.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    instagram.form = instagramForm